import { ProfileCustomValuesList } from "PFApp/components/custom_values_list";
import { Inline, Stack } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { MatchedCustomValue, PureCustomValue } from "PFCore/types";
import { IconName } from "PFTheme/graphics/icons";

import { useCustomValuePreviewContext } from "../../context/custom_value_preview_context";
import css from "./parent_child_section.module.scss";

type SubsectionContentProps = {
  iconName: IconName;
  mainTitle: string;
  sideText: string;
  skills: (MatchedCustomValue["customValue"] | PureCustomValue)[];
};

export const SubsectionContent = ({ iconName, mainTitle, sideText, skills }: SubsectionContentProps) => {
  const { profileId } = useCustomValuePreviewContext();

  return (
    <Stack className={css.subsection} gap="spacingLg">
      <Inline gap="spacingSm" alignItems="center">
        <Icon name={iconName} size="sm" />
        <Typography variant="bodyBold">{mainTitle}</Typography>
        <Typography variant="bodyRegular">{sideText}</Typography>
      </Inline>
      <ProfileCustomValuesList
        customFieldName="skills"
        customValues={skills}
        profileId={profileId!}
        allowPreview={false}
      />
    </Stack>
  );
};
